import React, { useMemo } from 'react';
import type { FC } from 'react';
import type { SelectGroup } from '@wix/cli-ui-kit';
import { Link, SelectGroupsInput, Text } from '@wix/cli-ui-kit';
import {
  // vibeCompatibleTemplates,
  pureHeadlessTemplates,
  TemplateSource,
} from '../parse-command-options.js';

export interface CliHeadlessTemplate {
  name: string;
  title: string;
  subtitle: string;
  siteTemplateId: string;
  gitPath: string;
  vibeCompatible: boolean;
}

export const ChooseTemplate: FC<{
  onSubmit: (data: { template: TemplateSource }) => void;
}> = ({ onSubmit }) => {
  const groups: Array<SelectGroup<CliHeadlessTemplate>> = useMemo(
    () => [
      // {
      //   title: 'Wix Vibe compatible templates',
      //   items: vibeCompatibleTemplates.map((template) => ({
      //     key: template.siteTemplateId,
      //     title: template.title,
      //     description: template.subtitle,
      //     value: template,
      //   })),
      // },
      {
        title: 'Standard templates',
        // https://dev.wix.com/docs/go-headless/get-started/templates/wix-managed-templates/wix-cli-for-headless-templates
        description: (
          <Text>
            (<Link url="https://wix.to/zuKh3Fo">Learn more</Link>)
          </Text>
        ),
        items: pureHeadlessTemplates.map((template) => ({
          key: template.siteTemplateId,
          title: template.title,
          description: template.subtitle,
          value: template,
        })),
      },
    ],
    []
  );

  return (
    <SelectGroupsInput<CliHeadlessTemplate>
      label="Select an initial template for your business"
      groups={groups}
      onSubmit={({ value }) =>
        onSubmit({ template: TemplateSource.HeadlessApp(value) })
      }
    />
  );
};
